import { Filter, getFilterValue } from '../data/filters';
import { ReportConfigColumn } from '../types/ReportConfigColumn';

export const getDefaultVisibleOfColumn = (configColumn: ReportConfigColumn, filter: Filter, newReport: boolean) => {
    if (newReport && configColumn.exactValuesToSetVisibleByDefault?.length) {
        const filterValue = getFilterValue(filter);

        if (filterValue && configColumn.exactValuesToSetVisibleByDefault.includes(filterValue)) {
            return true;
        }
    }

    return configColumn.visible;
};
